import { SiafLiteApiRepository, SiafLiteApiStream } from "../../external";
import store from "../../config/store";

class DreService {
  constructor() {
    this.urlBase = "faturamento/dre";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getReceitaMensal(body) {
    return new SiafLiteApiRepository(`${this.urlBase}/receita-mensal`).patch(
      body,
    );
  }

  gerarPdf(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/dashboard-pdf`,
    ).path(body);
  }
}

export default DreService;
